import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortTask'
})
export class SortTaskPipe implements PipeTransform {
  transform(value: any, args: any ): any {
    const searchText = args.searchText&&args.searchText.toLowerCase().trim();
    const labels = args.labels || [];
    if(value && (searchText || labels.length)){
      return value.filter(x=> {
        const item = JSON.stringify(x).toLowerCase();
        let searchTextMatch = false;
        let labelTextMatch = false;
        if(searchText)
          searchTextMatch = item.includes(searchText);
        if(labels.length)
          labelTextMatch = this.sortByLabel(item, labels);
        
          if(!searchText && !labels.length)
            return true;
          else if((searchText&&searchTextMatch) && (labels.length&&labelTextMatch))
            return true;
          else if(!searchText && (labels.length&&labelTextMatch))
            return true;
          else if((searchText&&searchTextMatch) && !labels.length)
            return true;
      })
    }
    return value;
  }

  sortByLabel(item, labels){
    return labels.filter(x=> x&&item.includes(x.labelText.toLowerCase())).length;
  }

}
